import * as React from 'react';
import { styled } from '@linaria/react';
import { animated, useSpring } from 'react-spring';

import { ToolButtonContext } from './ToolButton';

interface Props extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

function IconEraser({ size = 24, ...props }: Props) {
  const isBooped = React.use(ToolButtonContext);

  const spring = useSpring({
    transform: `translateX(${isBooped ? 3 : 0}px)`,
    config: {
      tension: 300,
      friction: 10,
    },
  });

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      {...props}
    >
      <path
        d="M22 22H2"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <animated.path
        style={spring}
        d="M5.5 12.5L4.03109 13.9689C2.89536 15.1046 2.85562 16.9334 3.94095 18.1174L7.5 22H12L13.5 20.5M5.5 12.5L11.8787 6.12132C13.0503 4.94975 14.9497 4.94975 16.1213 6.12132L19.8787 9.87868C21.0503 11.0503 21.0503 12.9497 19.8787 14.1213L13.5 20.5M5.5 12.5L13.5 20.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}

const Svg = styled.svg`
  overflow: visible;
`;

export default IconEraser;
